import { render, staticRenderFns } from "./historicalRecord.vue?vue&type=template&id=2902a6b7&"
import script from "./historicalRecord.vue?vue&type=script&lang=js&"
export * from "./historicalRecord.vue?vue&type=script&lang=js&"
import style0 from "./historicalRecord.vue?vue&type=style&index=0&id=2902a6b7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports